"use strict";

/*==============================================================================
TRESTLE W008
TRESTLE CURATED RECOMMENDATIONS
PRODUCT INTELLIGENCE DATA

Brand        : Diafemme®
Module       : W008
File         : TRESTLE_W008_Recommendations_Data.js
Version      : 1.0

Purpose
-------
• Maintain the curated TRESTLE product recommendation map
• Match products against the user's W002 TRESTLE Profile
• Keep recommendation intelligence separate from Shopify commerce data

IMPORTANT
---------
Shopify remains the source of truth for:

• Product title
• Product image
• Current selling price
• Compare-at / MRP price
• Product availability
• Product URL

Do NOT hard-code prices or product images in this file.

W008 uses only the Shopify product handle plus TRESTLE recommendation rules.

Profile source:
localStorage["trestleProfile"]

Canonical W002 dimensions:
• promise
• lifeStage
• diabetesType
==============================================================================*/


const TRESTLE_W008_PRODUCT_DATA = [


/*==============================================================================
NATURAL SOLUTIONS
==============================================================================*/


{
    id: "NS01",

    handle: "she-dia-balance-powder-women",

    category: "Natural Solutions",

    relevance: {

        promise: [
            "More Energy",
            "Healthier Living"
        ],

        lifeStage: [],

        diabetesType: [
            "Prediabetes",
            "Type 2 Diabetes"
        ]

    },

    weights: {

        promise: 2,
        lifeStage: 0,
        diabetesType: 1

    },

    gate: null,

    active: true
},


{
    id: "NS02",

    handle: "jamun-seed-powder",

    category: "Natural Solutions",

    relevance: {

        promise: [
            "Healthier Living"
        ],

        lifeStage: [],

        diabetesType: [
            "Prediabetes",
            "Type 2 Diabetes"
        ]

    },

    weights: {

        promise: 1,
        lifeStage: 0,
        diabetesType: 3

    },

    gate: {

        type: "diabetesType",

        values: [
            "Prediabetes",
            "Type 2 Diabetes"
        ]

    },

    active: true
},


{
    id: "NS03",

    handle: "jamun-capsules-ayurvedic",

    category: "Natural Solutions",

    relevance: {

        promise: [
            "Healthier Living"
        ],

        lifeStage: [],

        diabetesType: [
            "Prediabetes",
            "Type 2 Diabetes"
        ]

    },

    weights: {

        promise: 1,
        lifeStage: 0,
        diabetesType: 3

    },

    gate: {

        type: "diabetesType",

        values: [
            "Prediabetes",
            "Type 2 Diabetes"
        ]

    },

    active: true
},


{
    id: "NS04",

    handle: "fenugreek-seed-powder",

    category: "Natural Solutions",

    relevance: {

        promise: [
            "Healthier Living"
        ],

        lifeStage: [],

        diabetesType: [
            "Prediabetes",
            "Type 2 Diabetes"
        ]

    },

    weights: {

        promise: 2,
        lifeStage: 0,
        diabetesType: 1

    },

    gate: null,

    active: true
},


/*==============================================================================
HERBAL TEAS
==============================================================================*/


{
    id: "HT01",

    handle: "ashwagandha-green-tea",

    category: "Herbal Tea",

    relevance: {

        promise: [
            "More Calmness",
            "Balanced Life"
        ],

        lifeStage: [],

        diabetesType: []

    },

    weights: {

        promise: 2,
        lifeStage: 0,
        diabetesType: 0

    },

    gate: null,

    active: true
},


{
    id: "HT02",

    handle:
        "diabetes-support-tea-herbal-balance-tea-for-everyday-blood-sugar-wellness",

    category: "Herbal Tea",

    relevance: {

        promise: [
            "Healthier Living"
        ],

        lifeStage: [],

        diabetesType: [
            "Prediabetes",
            "Type 2 Diabetes"
        ]

    },

    weights: {

        promise: 1,
        lifeStage: 0,
        diabetesType: 3

    },

    gate: {

        type: "diabetesType",

        values: [
            "Prediabetes",
            "Type 2 Diabetes"
        ]

    },

    active: true
},


{
    id: "HT03",

    handle: "menopause-support-tea",

    category: "Herbal Tea",

    relevance: {

        promise: [
            "Better Sleep",
            "More Calmness"
        ],

        lifeStage: [
            "Perimenopause",
            "Menopause"
        ],

        diabetesType: []

    },

    weights: {

        promise: 1,
        lifeStage: 3,
        diabetesType: 0

    },

    /*
    Menopause Support Tea must NOT become a recommendation
    merely because Better Sleep / More Calmness matches.

    Relevant life-stage context is required.
    */

    gate: {

        type: "lifeStage",

        values: [
            "Perimenopause",
            "Menopause"
        ]

    },

    active: true
},


{
    id: "HT04",

    handle: "organic-chamomile-tea",

    category: "Herbal Tea",

    relevance: {

        promise: [
            "Better Sleep",
            "More Calmness"
        ],

        lifeStage: [],

        diabetesType: []

    },

    weights: {

        promise: 2,
        lifeStage: 0,
        diabetesType: 0

    },

    gate: null,

    active: true
},


{
    id: "HT05",

    /*
    Current Shopify URL uses a legacy product handle.
    Product displayed on Diafemme: PCOS Support Tea
    */

    handle:
        "diabetes-support-tea-herbal-balance-tea-for-everyday-blood-sugar-wellness-copy",

    category: "Herbal Tea",

    relevance: {

        promise: [
            "Healthier Living"
        ],

        lifeStage: [
            "Reproductive Years"
        ],

        diabetesType: []

    },

    weights: {

        promise: 1,
        lifeStage: 3,
        diabetesType: 0

    },

    /*
    W002 does not ask whether the user has PCOS.

    Therefore Reproductive Years makes this product contextually
    eligible, but W008 must NEVER imply that TRESTLE knows the
    user has PCOS.
    */

    gate: {

        type: "lifeStage",

        values: [
            "Reproductive Years"
        ]

    },

    active: true
},


{
    id: "HT06",

    /*
    Current Shopify URL uses a legacy product handle.
    Product displayed on Diafemme: Sleep Support Tea
    */

    handle:
        "pcos-support-tea-herbal-wellness-blend-for-hormonal-balance-copy",

    category: "Herbal Tea",

    relevance: {

        promise: [
            "Better Sleep",
            "More Calmness"
        ],

        lifeStage: [],

        diabetesType: []

    },

    weights: {

        promise: 3,
        lifeStage: 0,
        diabetesType: 0

    },

    gate: null,

    active: true
},


/*==============================================================================
DIABETIC EDIBLES
==============================================================================*/


{
    id: "DE01",

    handle: "zero-sugar-millet-cookies",

    category: "Diabetic Edibles",

    relevance: {

        promise: [
            "Healthier Living"
        ],

        lifeStage: [],

        diabetesType: [
            "Prediabetes",
            "Type 2 Diabetes"
        ]

    },

    weights: {

        promise: 2,
        lifeStage: 0,
        diabetesType: 2

    },

    gate: null,

    active: true
},


{
    id: "DE02",

    handle: "whole-wheat-garlic-masala-sticks",

    category: "Diabetic Edibles",

    relevance: {

        promise: [
            "Healthier Living"
        ],

        lifeStage: [],

        diabetesType: []

    },

    weights: {

        promise: 2,
        lifeStage: 0,
        diabetesType: 0

    },

    gate: null,

    active: true
},


{
    id: "DE03",

    handle: "diabetes-care-red-rice-congee",

    category: "Diabetic Edibles",

    relevance: {

        promise: [
            "Healthier Living"
        ],

        lifeStage: [],

        diabetesType: [
            "Prediabetes",
            "Type 2 Diabetes"
        ]

    },

    weights: {

        promise: 2,
        lifeStage: 0,
        diabetesType: 3

    },

    /*
    This remains available as a general food product through a
    Healthier Living match, so it is NOT hard-gated by diabetes.
    Diabetes context simply raises its relevance considerably.
    */

    gate: null,

    active: true
},


{
    id: "DE04",

    handle: "millet-protein-soup",

    category: "Diabetic Edibles",

    relevance: {

        promise: [
            "Healthier Living"
        ],

        lifeStage: [],

        diabetesType: []

    },

    weights: {

        promise: 2,
        lifeStage: 0,
        diabetesType: 0

    },

    gate: null,

    active: true
},


/*==============================================================================
FOOT & SKIN
==============================================================================*/


{
    id: "FS01",

    handle: "diabetic-socks",

    category: "Foot & Skin",

    relevance: {

        promise: [],

        lifeStage: [],

        diabetesType: [
            "Type 1 Diabetes",
            "Type 2 Diabetes"
        ]

    },

    weights: {

        promise: 0,
        lifeStage: 0,
        diabetesType: 4

    },

    /*
    Diabetic Socks are highly context-specific.

    They must only enter Recommended for You when the user's
    diabetes profile is Type 1 Diabetes or Type 2 Diabetes.
    */

    gate: {

        type: "diabetesType",

        values: [
            "Type 1 Diabetes",
            "Type 2 Diabetes"
        ]

    },

    active: true
}


/*==============================================================================
END PRODUCT DATA
==============================================================================*/

];


/*==============================================================================
W008 CONFIGURATION
==============================================================================*/

const TRESTLE_W008_CONFIG = {

    /*
    Maximum number of products displayed in
    "Recommended for You".
    */

    maxRecommendations: 4,


    /*
    Maximum number displayed at one time / initial Explore pool.
    The rendering engine may carousel through additional products.
    */

    maxExploreInitial: 8,


    /*
    Product diversity prevents four very similar products from
    dominating Recommended for You when other strongly relevant
    product categories are available.
    */

    preferCategoryDiversity: true,


    /*
    A product must score above zero after passing any contextual
    gate before it can enter Recommended for You.
    */

    minimumRecommendationScore: 1

};


/*==============================================================================
PUBLIC DATA ACCESS
==============================================================================*/

window.TRESTLE_W008_PRODUCT_DATA =
    TRESTLE_W008_PRODUCT_DATA;


window.TRESTLE_W008_CONFIG =
    TRESTLE_W008_CONFIG;


/*==============================================================================
END W008 DATA
==============================================================================*/